
<template>
  <div class="editor">
    <v-container class="pt-10">
      <v-row class="py-2 px-3 pt-1">
        <h1>EDITOR</h1>
      </v-row>
      <v-row class="py-2 px-3 pt-1">
        <v-switch v-model="editable"></v-switch>
        <v-row class="py-2 px-3 pt-1">
          <p v-if="transcript">
            Status: {{ transcript.status.progress }} Duration:
            {{ transcript.metadata.audioDuration }}
          </p>
        </v-row>
      </v-row>
      <v-row class="py-2 px-3 pt-1" v-if="!hide">
        <editor-menu-bar
          :editor="editor"
          v-slot="{ commands, isActive }"
          v-if="editable"
        >
          <div class="menubar">
            <v-btn
              class="menubar__button"
              :class="{ 'is-active': isActive.bold() }"
              @click="commands.bold"
            >
              Bold
            </v-btn>

            <v-btn
              class="menubar__button"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
            >
              <!-- <icon name="italic" /> -->
              Italic
            </v-btn>

            <v-btn
              class="menubar__button"
              :class="{ 'is-active': isActive.strike() }"
              @click="commands.strike"
            >
              <!-- <icon name="strike" /> -->
              Strike
            </v-btn>

            <v-btn
              class="menubar__button"
              :class="{ 'is-active': isActive.underline() }"
              @click="commands.underline"
            >
              <!-- <icon name="underline" /> -->
              Underline
            </v-btn>

            <v-btn
              class="menubar__button"
              :class="{ 'is-active': isActive.paragraph() }"
              @click="commands.paragraph"
            >
              <!-- <icon name="paragraph" /> -->
              Paragraph
            </v-btn>

            <v-btn class="menubar__button" @click="commands.undo">
              <!-- <icon name="undo" /> -->
              Undo
            </v-btn>

            <v-btn class="menubar__button" @click="commands.redo">
              <!-- <icon name="redo" /> -->
              Redo
            </v-btn>
          </div>
        </editor-menu-bar>
      </v-row>
      <v-row class="py-2 px-3 pt-1">
        <editor-content class="editor__content" :editor="editor" />
      </v-row>
      <v-row class="py-2 px-3 pt-1">
        <h1>JSON</h1>
        <p v-if="json">{{ updatedJSON }}</p>
      </v-row>
      <v-row class="py-2 px-3 pt-1">
        <h1>TASK DESCRIPTION</h1>
        <p>
          1) Display in the editor the whole transcription, divided by
          paragraphs, keeping the metadata of each segment of words (confidence,
          text, startTime, endTime). <br />
          2) The user should be able to edit a word in the transcription, and
          the output json should still keep the initial metadata for each
          segment (confidence, text, startTime, endTime). <br />
          3) When editing a word, only the paragraph that contains that word
          should render. Console log the id of the paragraph rendered.
        </p>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { transcriptsCollection } from "@/plugins/firebase.js";

// import Icon from '../../components/editor/Icon'
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from "tiptap-extensions";
export default {
  components: {
    EditorContent,
    EditorMenuBar,
    // Icon,
  },
  data() {
    return {
      transcript: null,
      paragraphs: null,

      hide: true,

      editor: new Editor({
        editable: false,
        disablePasteRules: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: `
          <p>A</p>
        `,
        onUpdate: ({ getJSON, getHTML }) => {
          this.json = getJSON();
          this.html = getHTML();
        },
      }),
      editable: false,
      editorcontent: null,
      json: "Update content to see changes",
      html: "Update content to see changes",
      selectedPara: null,
      updatedJSON: null,
    };
  },
  watch: {
    editable() {
      this.editor.setOptions({
        editable: this.editable,
      });
    },
    editorcontent(allParagraph) {
      let paragraphs = [];
      allParagraph.forEach(function (paragraph) {
        paragraphs.push({
          type: "paragraph",
          content: [
            {
              type: "text",
              text: paragraph.words.map((w) => w.text).join(" "),
            },
          ],
        });
      });
      this.editor.setContent(
        {
          type: "doc",
          content: paragraphs,
        },
        true
      );
      // this.selectedPara = paragraph
      this.editor.focus();
    },
    json(updatedJSON) {
      console.log("Updated JSON: ", updatedJSON);
      this.parseAndUpdateJSON(updatedJSON);
    },
  },
  methods: {
    setEditorContent(event, paragraph) {
      console.log("para ID: ", event);
      this.editorcontent = paragraph;
    },
    async fetchTranscription(id) {
      let doc = await transcriptsCollection.doc(id).get();
      let transcript = doc.data();
      transcript.id = doc.id;
      this.transcript = transcript;
    },
    async fetchTranscriptionParagraphs(id) {
      const paragraphs = [];
      await transcriptsCollection
        .doc(id)
        .collection("paragraphs")
        // .where('type', '!=', 'nested-parent')
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            let singleParagraph = doc.data();
            singleParagraph.id = doc.id;
            paragraphs.push(singleParagraph);
            // console.log(
            //   "par " + doc.id + " --> " + singleParagraph.words.length
            // );
            if (doc.id === "ymfkASQIQe7veCYnno5x") {
              let sentence = [];
              let a = singleParagraph.words;
              a.map((item) => {
                if (item.updatedText) {
                  sentence.push(item.updatedText);
                } else {
                  sentence.push(item.text);
                }
                // console.log(item);
              });
              console.log(sentence);
            }
          });
        })
        .catch((err) => console.log(err));
      this.paragraphs = paragraphs;
      this.editorcontent = this.paragraphs;
    },
    parseAndUpdateJSON: function (updatedJSON) {
      /* eslint-disable */
      // console.log("Updated Text", updatedJSON.content[0].content[0].text);
      let words = [];
      let paragraphsWithMarks = updatedJSON.content; // all paragraphs
      paragraphsWithMarks.forEach(function (paraWithMark) {
        paraWithMark.content.forEach(function (paraTextWithMarks) {
          let innerWords = paraTextWithMarks.text.split(" ").filter(Boolean);
          let marks =
            paraTextWithMarks.marks != undefined
              ? paraTextWithMarks.marks.map((mark) => mark.type)
              : [];
          if (innerWords.length > 1) {
            innerWords.forEach(function (innerWord) {
              words.push({
                type: "text",
                marks: marks,
                text: innerWord,
              });
            });
          } else if (innerWords.length > 0) {
            words.push({
              type: "text",
              marks: marks,
              text: innerWords[0],
            });
          }
        });
      });
      console.log("Extracted Words with editor marks and meta deta", words);
      let iterator = 0;
      this.paragraphs.forEach(function (paragraph, paraIndex) {
        paragraph.words.forEach(function (word, wordIndex) {
          word.text = words[iterator].text;
          if (word.marks == undefined) word.marks = [];
          word.marks = words[iterator].marks;
          iterator++;
        });
      });
      console.log("Length of words: ", words.length);

      // this.selectedPara.words.forEach(function(word, index) {
      //   word.text = words[index].text
      //   if(word.marks == undefined) word.marks = []
      //   word.marks = words[index].marks
      // });
      let allWords = this.paragraphs.map((p) => p.words).flat();
      this.updatedJSON = JSON.stringify(allWords);
    },
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  created() {
    this.fetchTranscription(this.$route.params.id);
    this.fetchTranscriptionParagraphs(this.$route.params.id);
  },
};
</script>

<style scoped>
.editor__content {
  min-width: 100%;
}
</style>
